import DisplayEntity from 'components/PageBuilder/DisplayEntity';
import IndexWithSearchBar from 'components/PageBuilder/IndexWithSearchBar';
import DeleteMenuOption from 'components/TableMonitoring/Body/RowMenuListActions/DeleteMenuOption';
import EditMenuOption from 'components/TableMonitoring/Body/RowMenuListActions/EditMenuOption';
import TableHeaderStatic from 'components/TableMonitoring/Header/Static/TableHeaderStatic';
import TableMonitoring from 'components/TableMonitoring';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initializePatientNotes } from 'redux/reducers/notesReducer';
import NotesTableRows from './NotesTableRows';
import TableRowStatic from 'components/TableMonitoring/Body/TableRowStatic';
import { CommonTexts, notesTexts } from 'locale/es';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import Loader from 'components/Loader/Loader';
import NoDataTableBody from 'components/TableMonitoring/Body/NoDataTableBody';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import DrawerHeader from 'components/DrawerHeader';
import BreadCrumbs from 'components/Breadcrumbs/Breadcrumbs';
import { useFilterContext } from 'context/FilterContext';
import { useFilter } from 'hooks/useFilter';
import FilterTable from 'components/TableMonitoring/Toolbar/Filter';

function Notes({ isDashboard }) {
  const patient = useSelector(({ patient }) => patient);

  const { data, loading, error } = useSelector(({ notes }) => notes);
  const { selectedFilter, searchTerm } = useFilterContext();

  const tableHeaders = [
    { name: 'Fecha', value: 'noteDate' },
    { name: 'Autor', value: 'author' },
    { name: 'Nota', value: 'text' },
  ];

  const adaptedTableHeaders = tableHeaders.map((header) => header.name);
  const { filteredData } = useFilter(data, adaptedTableHeaders);

  const dispatch = useDispatch();

  useEffect(() => {
    if (patient.id && data?.length === 0) {
      dispatch(initializePatientNotes(patient.id));
    }
  }, [patient.id, dispatch]);

  if (loading) {
    return <Loader message={notesTexts.LOADING} pt={32} />;
  }

  const containerStyles = patient.id
    ? { width: 350, mt: 2, mb: -2 }
    : { p: 2, m: 2, mx: { md: 10, lg: 30 } };

  return (
    <Box
      component='main'
      sx={!isDashboard ? { flex: 1, p: 3, mb: 20 } : { mb: 20, mt: -4 }}>
      {!isDashboard && (
        <>
          <DrawerHeader />
          <BreadCrumbs
            name={CommonTexts.NOTES}
            icon={<TextSnippetIcon sx={{ mr: 0.5 }} fontSize='inherit' />}
          />
          <Box sx={containerStyles}>
            <IndexWithSearchBar />
          </Box>
        </>
      )}
      <DisplayEntity entityId={patient.id}>
        <FilterTable data={data} tableHeaders={tableHeaders} />
        <TableMonitoring
          patientId={patient.id}
          tableHeader={
            <TableHeaderStatic
              tableHeaders={adaptedTableHeaders}
              entity={patient}
              canCreate={!isDashboard}
            />
          }>
          {(selectedFilter && !searchTerm ? data : filteredData).map((note) => (
            <TableRowStatic
              key={note.id}
              entity={note}
              loaded={!loading}
              actions={
                <>
                  {!isDashboard && (
                    <>
                      <EditMenuOption entity={note} />
                      <DeleteMenuOption entityId={note.id} />
                    </>
                  )}
                </>
              }>
              <NotesTableRows note={note} />
            </TableRowStatic>
          ))}
        </TableMonitoring>
        {data?.length === 0 && (
          <NoDataTableBody
            entity={patient.id}
            noDataMessage={notesTexts.NO_DATA}
          />
        )}
        {data?.length > 0 && filteredData?.length === 0 && searchTerm && (
          <NoDataTableBody
            entity={patient.id}
            noDataMessage={notesTexts.NO_DATA_FILTERS}
          />
        )}
      </DisplayEntity>
      <Outlet />
    </Box>
  );
}

export default Notes;
